<div class="d-flex justify-content-end align-items-center">
    <button class="history-btn " type="button" (click)="history()">History</button>
</div>
